import { CALYPSO, CANDY_APPLE_DARK, OBSIDIAN, OZ } from 'HubStyleTokens/colors';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { Data } from 'signup-constants/signupData/Data';
import { useSignupData } from '../signup-data/useSignupData';
import { devices } from 'signup-constants/styles/viewports.styles';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { isLeftAlignedLayout } from '../utils/isLeftAlignedLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const handleInputColor = (isInvalid, isValid) => {
  if (isInvalid) return CANDY_APPLE_DARK;
  if (isValid) return OZ;
  return CALYPSO;
};
const StyledCodeVerificationInput = styled.div.withConfig({
  displayName: "CodeVerificationInput__StyledCodeVerificationInput",
  componentId: "d9ujp0-0"
})(["display:flex;justify-content:space-between;align-items:center;padding-top:1em;", " input{text-align:center;font-size:28px;padding-top:14px !important;padding-bottom:18px !important;height:40px;width:36px;line-height:22px;border:none;padding:9px 10px;color:", ";border-bottom-width:2px;border-bottom-style:solid;border-bottom-color:", ";border-radius:0;:focus{outline:none;}@media ", "{width:48px;}}"], props => isLeftAlignedLayout(props.layoutType) && `
    @media ${devices.desktop} {
    width: 420px;
  }
  `, OBSIDIAN, props => props.statusColor, devices.tablet);
const CodeVerificationInput = ({
  isValid,
  isInvalid
}) => {
  const {
    layoutType
  } = useLayoutTemplate();
  const inputsRef = useRef([]);
  const [code, setCode] = useState(Array(6).fill(''));
  const {
    setData
  } = useSignupData(Data.CodeVerification);
  const updateCodeValue = (index, value) => {
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
    setData(newCode.join(''));
  };
  const handleOnKeyUp = (event, index) => {
    const {
      key
    } = event;
    // Handle clearing of input
    if (key === 'Backspace' || key === 'Delete') {
      const existingChar = code[index];
      const isFirstInput = index === 0;
      if (existingChar === '') {
        // Clear previous input value
        if (!isFirstInput) {
          updateCodeValue(index - 1, '');
        }

        // Autofocus to previous input
        if (!isFirstInput) {
          const previousInput = inputsRef.current[index - 1];
          if (previousInput !== null) {
            previousInput.focus();
          }
        }
      } else {
        // Clear current input value
        updateCodeValue(index, '');
      }
    }

    // Handle number input
    const number = event.key;
    if (/[^0-9]/.test(number)) return;
    updateCodeValue(index, number);

    // Autofocus to next input
    const isLastInput = index === code.length - 1;
    if (!isLastInput) {
      const nextInput = inputsRef.current[index + 1];
      if (nextInput !== null) {
        nextInput.focus();
      }
    }
  };
  const handleOnPaste = event => {
    const clipboardData = event.clipboardData.getData('text');
    const clipboardCode = clipboardData.split('').slice(0, 6);
    const newCode = Array(6).fill('');
    newCode.splice(0, clipboardCode.length, ...clipboardCode);
    setCode(newCode);
    setData(newCode.join(''));
    const lastCharInput = inputsRef.current[clipboardCode.length - 1];
    if (lastCharInput) {
      lastCharInput.focus();
    }
  };
  const handleOnChange = event => {
    const eventTarget = event.nativeEvent.target;
    if (/[^0-9]/.test(eventTarget.value)) {
      event.preventDefault();
    }
  };
  return /*#__PURE__*/_jsx(StyledCodeVerificationInput, {
    layoutType: layoutType,
    statusColor: handleInputColor(isInvalid, isValid),
    children: code.map((number, index) => {
      return /*#__PURE__*/_jsx("input", {
        inputMode: "numeric",
        maxLength: 1,
        ref: element => inputsRef.current[index] = element,
        type: "text",
        value: code[index],
        onChange: handleOnChange,
        onKeyUp: event => handleOnKeyUp(event, index),
        onPaste: event => handleOnPaste(event)
      }, index);
    })
  });
};
export default CodeVerificationInput;